const STORAGE_KEY = "ontik:store-origin";

/** Capture the exact parent origin supplied by the embedding store. */
export function captureStoreOrigin(windowObject = window) {
  try {
    const origin = new URLSearchParams(windowObject.location.search).get(
      "origin",
    );
    if (!origin) return null;

    const normalizedOrigin = new URL(origin).origin;
    windowObject.sessionStorage.setItem(STORAGE_KEY, normalizedOrigin);
    return normalizedOrigin;
  } catch {
    return null;
  }
}

export function isEmbeddedInStore(windowObject = window) {
  return windowObject.self !== windowObject.top;
}

export function getStoreOrigin(windowObject = window) {
  try {
    return windowObject.sessionStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
}

/** Send an event only to the store origin captured from the iframe URL. */
export function notifyStoreParent(message, windowObject = window) {
  if (!isEmbeddedInStore(windowObject)) return false;

  const origin = getStoreOrigin(windowObject);
  if (!origin) return false;

  try {
    windowObject.parent.postMessage(message, origin);
    return true;
  } catch {
    return false;
  }
}

/**
 * Third-party bank pages cannot reliably run inside the hosted-checkout iframe.
 * Ask the origin-pinned store parent to navigate its top-level page instead.
 */
export function redirectToThirdParty(url, windowObject = window) {
  const redirectUrl = new URL(url, windowObject.location.href);

  if (redirectUrl.protocol !== "https:") {
    throw new Error("Third-party payment redirects must use HTTPS.");
  }

  if (
    notifyStoreParent(
      {
        type: "ontik:hosted:redirect_required",
        redirectUrl: redirectUrl.href,
      },
      windowObject,
    )
  ) {
    return "parent";
  }

  windowObject.location.assign(redirectUrl.href);
  return "self";
}

if (typeof window !== "undefined") {
  captureStoreOrigin(window);
}
